// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onsiteSearchData = (data: any) => ({
  term: data?.term || '',
  results: data[data?.filter?.filter] || data?.results || '',
  ...(data?.resultsPosition && { resultPosition: data?.resultsPosition }),
  filter: data?.filter || '',
  searchComponent: data?.searchComponent || '',
});
